import { ServerErrorData } from '@libs/utils/error';
import { request } from '../request';

export async function assignShift(shiftId: string, assigneeId: string, doubleShiftId?: string | null) {
  const response = await request.post(`/v2/shifts/assign/${shiftId}`, {
    staffId: assigneeId,
    ...(doubleShiftId ? { doubleShiftOptions: { isDoubleShift: true, overlappedShiftId: doubleShiftId } } : {}),
  });
  return response;
}
export type AssignShiftError = Omit<ServerErrorData, 'title'> & {
  title:
    | 'StaffNotFound'
    | 'StaffDeactivated'
    | 'OverlapDetected'
    | 'ShiftNotFound'
    | 'ShiftRotationNotFound'
    | 'ShiftSeriesNotFound';
};

export async function requestAssignExternalShift(shiftId: string, assigneeId: string): Promise<void> {
  await request.post(`/v2/shifts/${shiftId}/external-assign-request`, {
    assigneeId,
  });
}

export async function unassignShift(shiftId: string, reason: string, reasonComment: string) {
  const response = await request.post(`/v2/shifts/unassign/${shiftId}`, {
    unassignReason: reason,
    reasonComment,
  });
  return response;
}
